import { Box } from "@mantine/core";

export const LayoutWorkstationFullscreen = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <Box w="100dvw" h="100dvh" bg={"gray.0"} pos={"relative"}>
      {children}
    </Box>
  );
};
